import React from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { Tooltip } from '@mui/material'
import clsx from 'clsx'

interface styleProps {
  background: string,
  borderColor: string,
  color: string,
  clickable: boolean,
  noBorder?: boolean,
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  content: {
    cursor: (props: styleProps) => props.clickable ? 'pointer' : 'unset',
    display: 'flex',
    padding: 4,
    alignItems: 'center',
    justifyContent: 'center',
    border: ({ noBorder }: styleProps) => noBorder ? 'none' : theme.border,
    borderRadius: '50%',
    height: 19,
    width: 19,
    background: (props: styleProps) => props.background,
    borderColor: ({ borderColor }: styleProps) => borderColor,
    '& svg *': {
      fill: (props: styleProps) => props.color,
    },
  },
  fixIcon: {
    marginLeft: 1,
    marginTop: 1,
  },
}))

interface StatusActionProps {
  onClick?: () => void
  color: string
  icon: string
  fixIcon?: boolean,
  tooltip?: string,
  invert?: boolean,
  size?: string
  disabled?: boolean,
  noBorder?: boolean,
}

const StatusAction = (props: StatusActionProps) => {
  const theme: ThemeInterface = useTheme()

  const { onClick, icon, size, invert, tooltip, fixIcon, disabled, noBorder } = props

  const color = invert ? theme.white : disabled ? theme.grey1 : props.color
  const background = invert ? disabled ? theme.grey1 : props.color : theme.white
  const borderColor = disabled ? theme.grey1 : props.color
  const classes = useStyles({ color, background, borderColor, clickable: !disabled, noBorder })

  const defaultSize = noBorder ? '15px' : '9px'

  return (
    <button className={classes.content} onClick={disabled ? () => {} : onClick}>
      {tooltip
        ? <Tooltip title={tooltip}>
          <SVGIcon className={clsx(fixIcon && classes.fixIcon)} svg={icon} width={size ?? defaultSize} fill={color} />
        </Tooltip>
        : <SVGIcon className={clsx(fixIcon && classes.fixIcon)} svg={icon} width={size ?? defaultSize} fill={color} />
      }
    </button>
  )
}

export default StatusAction
